// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NumberingModeController from "./numbering_mode_controller"
application.register("numbering-mode", NumberingModeController)

import PalletPickerController from "./pallet_picker_controller"
application.register("pallet-picker", PalletPickerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ExpenseItemController from "./expense_item_controller"
application.register("expense-item", ExpenseItemController)

import TransferFormController from "./transfer_form_controller"
application.register("transfer-form", TransferFormController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import ClientModalController from "./client_modal_controller"
application.register("client-modal", ClientModalController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import FormAutosubmitController from "./form_autosubmit_controller"
application.register("form-autosubmit", FormAutosubmitController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import PalletReturnController from "./pallet_return_controller"
application.register("pallet-return", PalletReturnController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import ProcessingSourcesController from "./processing_sources_controller"
application.register("processing-sources", ProcessingSourcesController)
